// extracted by mini-css-extract-plugin
export default {"drawer":"ca0588b4f464","panel":"e138b3507fd8","productAccessContainer":"d6856b8dbebb","actionsContainer":"f62fc37a6c9f"};